import axios from "axios";

let interceptorInstalled = false;

export function installAxiosInterceptors(store) {
  if (interceptorInstalled) return;
  interceptorInstalled = true;

  axios.defaults.baseURL = process.env.REACT_APP_API_HOST_URL;

  // Restore Authorization header from localStorage on app start so the first
  // requests don't go out unauthenticated.
  const storedToken = localStorage.getItem("admin_access_token");
  if (storedToken) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${storedToken}`;
  }

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;
      const code = error?.response?.data?.code;
      const isAuthFailure =
        status === 401 &&
        (code === "error.ERROR_INVALID_TOKEN" ||
         code === "error.ERROR_TOKEN_EXPIRED" ||
         code === "error.ERROR_NO_TOKEN_PROVIDED" ||
         code === "error.ERROR_TOKEN_PAYLOAD_NOT_FOUND");

      if (isAuthFailure) {
        const isOnLogin = window.location.pathname.startsWith("/login");
        const url = error?.config?.url || "";
        const isLoginRequest = url.includes("/sign-in") || url.includes("/check-session");

        if (!isOnLogin && !isLoginRequest) {
          // Tear down the session and bounce to /login.
          localStorage.removeItem("admin_access_token");
          localStorage.removeItem("admin_session_id");
          localStorage.removeItem("admin_session_expiration");
          delete axios.defaults.headers.common["Authorization"];

          if (store) {
            store.dispatch({ type: "session/clearSession" });
          }

          const returnTo = window.location.pathname + window.location.search;
          window.location.replace(`/login?returnTo=${encodeURIComponent(returnTo)}`);
        }
      }

      return Promise.reject(error);
    },
  );
}
